// `require.context` is a webpack API with no Vite equivalent; `import.meta.glob`
// is the replacement. Both patterns are single-level, matching the `false`
// (non-recursive) argument the require.context calls used, so clients/*.png
// still excludes the campaign/ subdirectory.
const normalizeKey = (path) =>
  path
    .split("/")
    .pop()
    .replace(/\.(png|svg)$/i, "")
    .toLowerCase()
    .replaceAll("_", " ");

const importAll = (modules) =>
  Object.fromEntries(
    Object.entries(modules).map(([path, url]) => [normalizeKey(path), url])
  );

const clientImages = importAll(
  import.meta.glob("../assets/img/clients/*.png", {
    eager: true,
    import: "default",
  })
);

// Campaign-specific wordmark logos (full logo with icon + text) stored under
// clients/campaign/. Supports both PNG and SVG so a buyer can drop either
// format.
const campaignClientImages = importAll(
  import.meta.glob("../assets/img/clients/campaign/*.{png,svg}", {
    eager: true,
    import: "default",
  })
);

const lookup = (map, clientName) => {
  if (!clientName) return null;
  const normalized = clientName.toLowerCase().trim();
  if (map[normalized]) return map[normalized];
  const simplified = normalized.replaceAll(/[.']/g, "");
  if (map[simplified]) return map[simplified];
  return null;
};

export const getClientLogo = (clientName) => lookup(clientImages, clientName);

// Full brand-logo lookup used by the campaign card / review modal.
// Falls back to `null` when the file isn't present — the caller is
// expected to render the client name text instead.
export const getCampaignClientLogo = (clientName) =>
  lookup(campaignClientImages, clientName);
